import React, { useEffect, useState, useCallback } from 'react';

import { Switch, Route, useLocation, useHistory, Redirect } from "react-router-dom";
import Home from "../../pages/Home";
import Login from "../../pages/Login";
import Layout from "../Layout";
import { checkEntity } from "./PageData/data";
import NotFound from "../../pages/NotFound";
import { Flex } from "@chakra-ui/react";

import ServicosAcolhimento from '../../pages/ServicosAcolhimento';
import ServicoAcolhimentoCadastrar from '../../pages/ServicosAcolhimento/Cadastrar';
import VisualizarServicoAtendimento from '../../pages/ServicosAcolhimento/Visualizar';
import ServicoAcolhimentoEditar from '../../pages/ServicosAcolhimento/Editar';

import PanelBase from '../../pages/ServicosAcolhimento/PanelBase';

import PerfilServicoAcolhimento from '../../pages/ServicosAcolhimento/Perfil';
import CadastrarPerfil from '../../pages/ServicosAcolhimento/Perfil/Cadastrar';
import EditarPerfil from '../../pages/ServicosAcolhimento/Perfil/Editar';

import CadastrarGestao from '../../pages/ServicosAcolhimento/Gestao/Cadastrar';
import GestaoServicoAcolhimento from '../../pages/ServicosAcolhimento/Gestao';
import EditarGestao from '../../pages/ServicosAcolhimento/Gestao/Editar';

import CadastrarPlanejamento from '../../pages/ServicosAcolhimento/Planejamento/Cadastrar';
import PlanejamentoServicoAcolhimento from '../../pages/ServicosAcolhimento/Planejamento';
import EditarPlanejamento from '../../pages/ServicosAcolhimento/Planejamento/Editar';

import CadastrarRedeReferencia from '../../pages/ServicosAcolhimento/RedeReferencia/Cadastrar';
import RedeReferenciaServicoAcolhimento from '../../pages/ServicosAcolhimento/RedeReferencia';
import EditarRedeReferencia from '../../pages/ServicosAcolhimento/RedeReferencia/Editar';

import EquipeServicoAcolhimento from '../../pages/ServicosAcolhimento/Equipe';

import VoluntariadoServicoAcolhimento from '../../pages/ServicosAcolhimento/Voluntariado';

import PessoaEmCumprimentoServicoAcolhimento from '../../pages/ServicosAcolhimento/PessoaEmCumprimento';

import FamiliaAcolhedoraServicoAcolhimento from '../../pages/ServicosAcolhimento/FamiliaAcolhedora';

import AnexosServicoAcolhimento from '../../pages/ServicosAcolhimento/Anexos';
import CadastrarAnexos from '../../pages/ServicosAcolhimento/Anexos/Cadastrar';

import RegularidadeServicoAcolhimento from '../../pages/ServicosAcolhimento/Regularidade';
import CadastrarRegularidade from '../../pages/ServicosAcolhimento/Regularidade/Cadastrar';
import EditarRegularidade from '../../pages/ServicosAcolhimento/Regularidade/Editar';

import { Criancas } from '../../pages/Criancas';
import { CadastrarCrianca } from '../../pages/Criancas/Cadastrar';
import { VisualizarCrianca } from '../../pages/Criancas/Visualizar'
import { EditarCrianca } from '../../pages/Criancas/Editar';

import { PanelBase as PanelBaseCrianca } from '../../pages/Criancas/PanelBase';

import { CadastrarDocumentacao } from '../../pages/Criancas/Documentacao/Cadastrar';
import { EditarDocumentacao } from '../../pages/Criancas/Documentacao/Editar';
import { VisualizarDocumentacao } from '../../pages/Criancas/Documentacao';

import { VisualizarMovimentacao } from '../../pages/Criancas/Movimentacao';
import { VisualizarSaude } from "../../pages/Criancas/Saude"

import RegistrarTipoServicoAcolhimento from "../../pages/TipoServicoAcolhimento/Registrar";
import ListaTipoServicoAcolhimento from "../../pages/TipoServicoAcolhimento/Lista";
import VisualizarTipoServicoAcolhimento from "../../pages/TipoServicoAcolhimento/Visualizar";
import EditarTipoServicoAcolhimento from "../../pages/TipoServicoAcolhimento/Editar";
import AlterarVigenciaTipoServicoAcolhimento from "../../pages/TipoServicoAcolhimento/AlterarVigencia";

import ListaMotivoSituacao from "../../pages/MotivoSituacao/Lista";
import ListaVisitas from "../../pages/Visitas/Lista";
import CadastrarVisitas from "../../pages/Visitas/Cadastrar";
import VisualizarVisitas from "../../pages/Visitas/Visualizar";
import RegistrarDoenca from "../../pages/Doenca/Registrar";
import CadastrarSituacaoJuridica from "../../pages/SituacaoJuridica/Cadastrar";
import ListaSituacaoJuridica from "../../pages/SituacaoJuridica/Lista";
import VisualizarSituacaoJuridica from "../../pages/SituacaoJuridica/Visualizar";
import EditarSituacaoJuridica from "../../pages/SituacaoJuridica/Editar";
import CadastrarMotivoSituacao from "../../pages/MotivoSituacao/Cadastrar";
import VisualizarMotivoSituacao from "../../pages/MotivoSituacao/Visualizar";
import EditarMotivoSituacao from "../../pages/MotivoSituacao/Editar";
import AlterarVigenciaMotivoSituacao from "../../pages/MotivoSituacao/AlterarVigencia";
import ListaDoenca from "../../pages/Doenca/Lista";
import VisualizarDoenca from "../../pages/Doenca/Visualizar";
import EditarDoenca from "../../pages/Doenca/Editar";
import AlterarVigenciaDoenca from "../../pages/Doenca/AlterarVigencia";
import AlterarVigenciaSituacaoJuridica from "../../pages/SituacaoJuridica/AlterarVigencia";
import { VisualizarProfissionalizacao } from '../../pages/Criancas/Profissionalizacao';
import { VisualizarEducacao } from '../../pages/Criancas/Educacao';
import { VisualizarReferenciaFamiliar } from '../../pages/Criancas/ReferenciaFamiliar/Visualizar';
import PrivateRoute from '../../../helpers/PrivateRoute';
import { VisualizarOcorrencias } from '../../pages/Criancas/Ocorrencias';
import { VisualizarVisita } from '../../pages/Criancas/Visita/Visitas/Visualizar';
import EditarVisitas from '../../pages/Visitas/Editar';
import { MessageContextProvider } from '../../../Context/MessageContextProvider';
import { SituacoesJuridicas } from '../../pages/Criancas/SituacaoJuridica/SituacoesJuridicas/Visualizar';
import { VisualizarAnexosCrianca } from '../../pages/Criancas/Anexos';
import { VisualizarApadrinhamento } from '../../pages/Criancas/Apadrinhamento';
import { VisualizarPendencia } from '../../pages/Criancas/Pendencias';


function Routes(props) {
  const [category, setCategory] = useState('');
  const [page, setPage] = useState('');
  const [entity, setEntity] = useState('');
  const [url, setUrl] = useState('');
  let history = useHistory();
  const urlfinal = useLocation();

  const [loading, setLoading] = useState(false);
  const [loadingPainel, setLoadingPainel] = useState(false);
  const [dataNascimento, setDataNascimento] = useState();

  const setLayoutData = useCallback(() => {
    const urlAarry = urlfinal.pathname.split("/");
    const layoutInformation = checkEntity(urlAarry[1], urlAarry[2]);

    if (layoutInformation) {
      setCategory(layoutInformation.currentCategory);
      setPage(layoutInformation.page);
      setEntity(layoutInformation.entity);
      setUrl(layoutInformation.href);
    }
    setLoading(false);
  }, [urlfinal, setCategory, setPage, setEntity, setUrl, setLoading]);

  useEffect(() => {
    setLoading(true)
    setLayoutData();
  }, [urlfinal, setLayoutData]);

  useEffect(() => {
    setLoadingPainel(false)
  }, [loadingPainel]);

  return (
    <Flex>

      <PrivateRoute>

        <MessageContextProvider>

          <Layout
            loading={loading}
            currentCateory={category}
            entidade={entity}
            entidadeHref={url}
            pagina={page}
          >

            <Switch history={history}>
              <Route exact path="/" component={Login} />
              <Route exact path="/dashboard">
                <Home />
              </Route>


              {/* SERVIÇOS DE ACOLHIMENTO */}
              <Route exact path="/servico-acolhimento" component={ServicosAcolhimento} />
              <Route exact path="/servico-acolhimento/cadastrar" component={ServicoAcolhimentoCadastrar} />
              <Route exact path="/servico-acolhimento/editar/:id">
                <PanelBase ><ServicoAcolhimentoEditar /></PanelBase>
              </Route>
              <Route exact path="/servico-acolhimento/:id">
                <PanelBase loadingPainel={loadingPainel} ><VisualizarServicoAtendimento setLoadingPainel={setLoadingPainel} /></PanelBase>
              </Route>
              {/* PERFIL */}
              <Route exact path="/servico-acolhimento/cadastrar-perfil/:id">
                <PanelBase ><CadastrarPerfil /></PanelBase>
              </Route>
              <Route exact path="/servico-acolhimento/editar-perfil/:id">
                <PanelBase ><EditarPerfil /></PanelBase>
              </Route>
              <Route exact path="/servico-acolhimento/visualizar-perfil/:id">
                <PanelBase><PerfilServicoAcolhimento /></PanelBase>
              </Route>
              {/* GESTÃO */}
              <Route exact path="/servico-acolhimento/cadastrar-gestao/:id">
                <PanelBase ><CadastrarGestao /></PanelBase>
              </Route>
              <Route exact path="/servico-acolhimento/visualizar-gestao/:id">
                <PanelBase><GestaoServicoAcolhimento /></PanelBase>
              </Route>
              <Route exact path="/servico-acolhimento/editar-gestao/:id">
                <PanelBase ><EditarGestao /></PanelBase>
              </Route>
              {/* PLANEJAMENTO */}
              <Route exact path="/servico-acolhimento/cadastrar-planejamento/:id">
                <PanelBase ><CadastrarPlanejamento /></PanelBase>
              </Route>
              <Route exact path="/servico-acolhimento/visualizar-planejamento/:id">
                <PanelBase><PlanejamentoServicoAcolhimento /></PanelBase>
              </Route>
              <Route exact path="/servico-acolhimento/editar-planejamento/:id">
                <PanelBase ><EditarPlanejamento /></PanelBase>
              </Route>
              {/* REDE DE REFERÊNCIA */}
              <Route exact path="/servico-acolhimento/cadastrar-rede-de-referencia/:id">
                <PanelBase ><CadastrarRedeReferencia /></PanelBase>
              </Route>
              <Route exact path="/servico-acolhimento/visualizar-rede-de-referencia/:id">
                <PanelBase><RedeReferenciaServicoAcolhimento /></PanelBase>
              </Route>
              <Route exact path="/servico-acolhimento/editar-rede-de-referencia/:id">
                <PanelBase ><EditarRedeReferencia /></PanelBase>
              </Route>
              {/* REGULARIDADE */}
              <Route exact path="/servico-acolhimento/cadastrar-regularidade/:id">
                <PanelBase ><CadastrarRegularidade /></PanelBase>
              </Route>
              <Route exact path="/servico-acolhimento/editar-regularidade/:id">
                <PanelBase ><EditarRegularidade /></PanelBase>
              </Route>
              <Route exact path="/servico-acolhimento/visualizar-regularidade/:id">
                <PanelBase><RegularidadeServicoAcolhimento /></PanelBase>
              </Route>
              {/* EQUIPE */}
              <Route exact path="/servico-acolhimento/visualizar-equipe/:id">
                <PanelBase ><EquipeServicoAcolhimento /></PanelBase>
              </Route>
              {/* VOLUNTARIADO */}
              <Route exact path="/servico-acolhimento/visualizar-voluntariado/:id">
                <PanelBase ><VoluntariadoServicoAcolhimento /></PanelBase>
              </Route>
              {/* PESSOA EM CUMPRIMENTO DE PENA */}
              <Route exact path="/servico-acolhimento/visualizar-pessoa-em-cumprimento-de-pena/:id">
                <PanelBase ><PessoaEmCumprimentoServicoAcolhimento /></PanelBase>
              </Route>
              {/* FAMILIA ACOLHEDORA */}
              <Route exact path="/servico-acolhimento/visualizar-familia-acolhedora/:id">
                <PanelBase><FamiliaAcolhedoraServicoAcolhimento /></PanelBase>
              </Route>
              {/* ANEXOS */}
              <Route exact path="/servico-acolhimento/visualizar-anexos/:id">
                <PanelBase><AnexosServicoAcolhimento /></PanelBase>
              </Route>
              <Route exact path="/servico-acolhimento/cadastrar-anexos/:id/categoria/:idCategoria">
                <PanelBase ><CadastrarAnexos /></PanelBase>
              </Route>

              {/* CRIANÇA */}
              <Route exact path="/crianca" component={Criancas} />
              <Route exact path="/crianca/cadastrar" component={CadastrarCrianca} />
              <Route exact path="/crianca/editar/:id">
                <PanelBaseCrianca  ><EditarCrianca /></PanelBaseCrianca>
              </Route>
              <Route exact path="/crianca/:id">
                <PanelBaseCrianca loadingPainel={loadingPainel} setLoadingPainel={setLoadingPainel}><VisualizarCrianca setLoadingPainel={setLoadingPainel} /></PanelBaseCrianca>
              </Route>

              {/* DOCUMENTACAO */}
              <Route exact path="/crianca/cadastrar-documentacao/:id">
                <PanelBaseCrianca setDataNascimento={setDataNascimento}><CadastrarDocumentacao dataNascimento={dataNascimento} /></PanelBaseCrianca>
              </Route>
              <Route exact path="/crianca/editar-documentacao/:id">
                <PanelBaseCrianca setDataNascimento={setDataNascimento}><EditarDocumentacao dataNascimento={dataNascimento} /></PanelBaseCrianca>
              </Route>
              <Route exact path="/crianca/visualizar-documentacao/:id">
                <PanelBaseCrianca setDataNascimento={setDataNascimento}><VisualizarDocumentacao dataNascimento={dataNascimento} /></PanelBaseCrianca>
              </Route>

              {/* MOVIMENTACAO */}
              <Route exact path="/crianca/visualizar-movimentacao/:id">
                <PanelBaseCrianca loadingPainel={loadingPainel} setDataNascimento={setDataNascimento}><VisualizarMovimentacao setLoadingPainel={setLoadingPainel} dataNascimento={dataNascimento} /></PanelBaseCrianca>
              </Route>

              {/* SAÚDE */}
              <Route exact path="/crianca/visualizar-saude/:id">
                <PanelBaseCrianca><VisualizarSaude /></PanelBaseCrianca>
              </Route>

              <Route exact path="/crianca/editar-saude/:id">
                <PanelBaseCrianca><VisualizarSaude /></PanelBaseCrianca>
              </Route>

              {/*APADRINHAMENTO */}
              <Route exact path="/crianca/visualizar-apadrinhamento/:id">
                <PanelBaseCrianca><VisualizarApadrinhamento /></PanelBaseCrianca>
              </Route>

              <Route exact path="/crianca/editar-apadrinhamento/:id">
                <PanelBaseCrianca><VisualizarApadrinhamento /></PanelBaseCrianca>
              </Route>



              {/* PROFISSIONALIZAÇÃO */}
              <Route exact path="/crianca/visualizar-profissionalizacao/:id">
                <PanelBaseCrianca><VisualizarProfissionalizacao /></PanelBaseCrianca>
              </Route>

              <Route exact path="/crianca/editar-profissionalizacao/:id">
                <PanelBaseCrianca><VisualizarProfissionalizacao /></PanelBaseCrianca>
              </Route>

              {/* REFERÊNCIA FAMILIAR */}
              <Route exact path="/crianca/visualizar-referencia-familiar/:id">
                <PanelBaseCrianca loadingPainel={loadingPainel}><VisualizarReferenciaFamiliar setLoadingPainel={setLoadingPainel} /></PanelBaseCrianca>
              </Route>

              {/* CRIANCA-VISITAS */}
              <Route exact path="/crianca/visualizar-visitas/:id">
                <PanelBaseCrianca loadingPainel={loadingPainel}><VisualizarVisita setLoadingPainel={setLoadingPainel} /></PanelBaseCrianca>
              </Route>

              {/* Ocorrências */}
              <Route exact path="/crianca/visualizar-ocorrencias/:id">
                <PanelBaseCrianca><VisualizarOcorrencias /></PanelBaseCrianca>
              </Route>

              <Route exact path="/crianca/editar-ocorrencias/:id/:idOrgaoExterno">
                <PanelBaseCrianca><VisualizarOcorrencias /></PanelBaseCrianca>
              </Route>

              <Route exact path="/crianca/cadastrar-ocorrencias/:id">
                <PanelBaseCrianca loadingPainel={loadingPainel} setLoadingPainel={setLoadingPainel}><VisualizarOcorrencias setLoadingPainel={setLoadingPainel} /></PanelBaseCrianca>
              </Route>

              {/* EDUCAÇÃO */}
              <Route exact path="/crianca/visualizar-educacao/:id">
                <PanelBaseCrianca><VisualizarEducacao /></PanelBaseCrianca>
              </Route>

              <Route exact path="/crianca/editar-educacao/:id">
                <PanelBaseCrianca><VisualizarEducacao /></PanelBaseCrianca>
              </Route>

              {/*SITUACAO JURIDICA CRIANÇA*/}
              <Route exact path="/crianca/visualizar-situacao-juridica/:id">
                <PanelBaseCrianca
                  loadingPainel={loadingPainel}
                  setLoadingPainel={setLoadingPainel}
                >
                  <SituacoesJuridicas setLoadingPainel={setLoadingPainel} />
                </PanelBaseCrianca>
              </Route>

              {/* ANEXOS CRIANÇA */}
              <Route exact path="/crianca/visualizar-anexos/:id">
                <PanelBaseCrianca setDataNascimento={setDataNascimento} loadingPainel={loadingPainel} setLoadingPainel={setLoadingPainel}><VisualizarAnexosCrianca dataNascimento={dataNascimento} setLoadingPainel={setLoadingPainel} /></PanelBaseCrianca>
              </Route>

              <Route exact path="/crianca/editar-anexos/:id/:idAnexo">
                <PanelBaseCrianca><VisualizarAnexosCrianca /></PanelBaseCrianca>
              </Route>

              <Route exact path="/crianca/cadastrar-anexos/:id">
                <PanelBaseCrianca loadingPainel={loadingPainel} setLoadingPainel={setLoadingPainel} setDataNascimento={setDataNascimento}><VisualizarAnexosCrianca dataNascimento={dataNascimento} setLoadingPainel={setLoadingPainel} /></PanelBaseCrianca>
              </Route>

              {/* PENDÊNCIAS */}
              <Route exact path="/crianca/visualizar-pendencias/:id">
                <PanelBaseCrianca ><VisualizarPendencia /></PanelBaseCrianca>
              </Route>

              {/* TIPO SERVIÇO ACOLHIMENTO */}

              <Route exact path="/tipo-servico-acolhimento/cadastrar" component={RegistrarTipoServicoAcolhimento} />
              <Route exact path="/tipo-servico-acolhimento/lista" loading={loading} component={ListaTipoServicoAcolhimento} />
              <Route exact path="/tipo-servico-acolhimento/:id" component={VisualizarTipoServicoAcolhimento} />
              <Route exact path="/tipo-servico-acolhimento/editar/:id" component={EditarTipoServicoAcolhimento} />
              <Route exact path="/tipo-servico-acolhimento/alterar-vigencia/:id" component={AlterarVigenciaTipoServicoAcolhimento} />

              {/*SITUACAO JURIDICA*/}
              <Route exact path="/situacao-juridica/cadastrar" component={CadastrarSituacaoJuridica} />
              <Route exact path="/situacao-juridica/lista" component={ListaSituacaoJuridica} />
              <Route exact path="/situacao-juridica/:id" component={VisualizarSituacaoJuridica} />
              <Route exact path="/situacao-juridica/editar/:id" component={EditarSituacaoJuridica} />
              <Route exact path="/situacao-juridica/alterar-vigencia/:id" component={AlterarVigenciaSituacaoJuridica} />

              {/*MOTIVO SITUACAO*/}
              <Route exact path="/motivo-situacao/cadastrar" component={CadastrarMotivoSituacao} />
              <Route exact path="/motivo-situacao/lista" component={ListaMotivoSituacao} />
              <Route exact path="/motivo-situacao/:id" component={VisualizarMotivoSituacao} />
              <Route exact path="/motivo-situacao/editar/:id" component={EditarMotivoSituacao} />
              <Route exact path="/motivo-situacao/alterar-vigencia/:id" component={AlterarVigenciaMotivoSituacao} />

              {/*DOENCA*/}
              <Route exact path="/doenca/cadastrar" component={RegistrarDoenca} />
              <Route exact path="/doenca/lista" component={ListaDoenca} />
              <Route exact path="/doenca/:id" component={VisualizarDoenca} />
              <Route exact path="/doenca/editar/:id" component={EditarDoenca} />
              <Route exact path="/doenca/alterar-vigencia/:id" component={AlterarVigenciaDoenca} />

              {/*VISITAS*/}
              <Route exact path="/visitas/cadastrar" component={CadastrarVisitas} />
              <Route exact path="/visitas/cadastrar/:id" component={CadastrarVisitas} />
              <Route exact path="/visitas/lista" component={ListaVisitas} />
              <Route exact path="/visitas/:id" component={VisualizarVisitas} />
              <Route exact path="/visitas/editar/:id" component={EditarVisitas} />

              <Route path={"/404"} exact component={NotFound} />
              <Redirect to={"/404"} />

            </Switch>
          </Layout>

        </MessageContextProvider>

      </PrivateRoute>


    </Flex >
  );
}

export default Routes;